<template>
  <p class="flex items-center space-x-4 text-sm">
    <Icon
      icon="check"
      class="shrink-0 text-green-500"
    />
    <span>{{ $t("market_preferred_suppliers") }}</span>
  </p>
</template>
